import token_img from 'assets/token.svg';
import { useGetTokenCostsQuery } from "services/api/tokenApi";
import styled from "styled-components";

const CostsSection: React.FC = () => {


  const { data: tokenCosts } = useGetTokenCostsQuery(undefined, {
    selectFromResult: ({ data }) => ({ data: data ?? null })
  });

  const dialogPhotoGenerationCost = tokenCosts?.dialogPhotoGenerationCost;

  return (
    <Root>
      <Row>
        <CostTitleContainer>
          <CostTitle>
            Image cost
          </CostTitle>
          <CostDescription>
            Cost per image
            <br />
            Only for custom scenarios for now
          </CostDescription>
        </CostTitleContainer>
        <Cost>{dialogPhotoGenerationCost}<TokenIcon src={token_img} /></Cost>
        <BetaBadge>Beta version</BetaBadge>
      </Row>
    </Root>
  );

};

export default CostsSection;

const Root = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #282828;
  border-radius: 12px;
  padding: 16px;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
  &:not(:last-child) {
    margin-bottom: 10px;
  }

  &:not(:last-child) {
    border-bottom: 1px solid #282828;
    padding-bottom: 10px;
  }
`;

const CostTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-width: 80%;
`;

const CostTitle = styled.div`
  font-family: Nunito Sans;
  font-weight: 700;
  font-size: 16px;
  line-height: 18px;
  color: #FFFFFF;
`;

const CostDescription = styled.div`
  font-family: Nunito Sans;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #A9A9A9;
`;

const Cost = styled(CostTitle)`
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 4px;
  color: #A9A9A9;
`;

const TokenIcon = styled.img`
  width: 16px;
  height: 16px;
`;

const BetaBadge = styled.div`
  position: absolute;
  bottom: -16px;
  right: -16px;
  background-color: rgb(255, 126, 95);
  color: white;
  font-size: 12px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 12px 0px;
  font-family: "Nunito Sans";

  @media (max-width: 600px) {
    font-size: 10px;
  }
`;
